import React, { useState, useCallback } from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';
import Button from '../components/button';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import { setQueueOpen, clearQueue } from '../store/api';
import { Queue } from '../store/types';

interface Props {
  queue: Queue;
  pin: string;
}

export default function QueueSettings({ queue, pin }: Props) {
  const params = useParams<{ organization: string; queue: string }>();
  const dispatch: AppDispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onChangeQueueOpen = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setLoading(true);
      dispatch(setQueueOpen({ ...params, open: event.target.checked, pin })).finally(() =>
        setLoading(false),
      );
    },
    [dispatch, params, pin],
  );
  const onClickClearQueue = useCallback(() => {
    setLoading(true);
    dispatch(clearQueue({ ...params, pin })).finally(() => setLoading(false));
  }, [dispatch, params, pin]);

  return (
    <Container>
      <Label>
        The queue is <strong>{queue.open ? 'open' : 'closed'}</strong>
        <Checkbox
          type="checkbox"
          checked={queue.open}
          onChange={onChangeQueueOpen}
          disabled={loading}
        />
        <Slider />
      </Label>
      {!queue.open && (
        <Button small danger onClick={onClickClearQueue} disabled={loading}>
          Clear Queue
        </Button>
      )}
    </Container>
  );
}

const Container = styled('div')`
  padding: 16px;
`;

const Label = styled('label')`
  display: flex;
  align-items: center;
  position: relative;

  strong {
    display: inline;
    padding-left: 6px;
  }
`;

const Slider = styled('span')`
  position: relative;
  cursor: pointer;
  height: 32px;
  width: 48px;
  margin: auto 0 auto auto;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 16px;

  &:before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 24px;
  }
`;

const Checkbox = styled('input')`
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + span {
    background-color: #2c9918;
  }
  &:focus + span {
    box-shadow: 0 0 1px #2c9918;
  }
  &:checked + span:before {
    transform: translateX(16px);
  }
`;
